import React from 'react'
import { Select, SelectItem } from '@/components/Select'

const states = [
  'Алтайский край',
  'Амурская область',
  'Архангельская область',
  'Астраханская область',
  'Белгородская область',
  'Брянская область',
  'Владимирская область',
  'Волгоградская область',
  'Вологодская область',
  'Воронежская область',
  'Донецкая Народная Республика (ДНР)',
  'Еврейская автоном. обл.',
  'Забайкальский край',
  'Запорожская область',
  'Ивановская область',
  'Иркутская область',
  'Кабардино-Балкарская Республика',
  'Калининградская область',
  'Калужская область',
  'Камчатский край',
  'Карачаево-Черкесская Республика',
  'Кемеровская область',
  'Кировская область',
  'Костромская область',
  'Краснодарский край',
  'Красноярский край',
  'Курганская область',
  'Курская область',
  'Ленинградская область',
  'Липецкая область',
  'Луганская Народная Республика (ЛНР)',
  'Магаданская область',
  'Москва',
  'Московская область',
  'Мурманская область',
  'Ненецкий АО',
  'Нижегородская область',
  'Новгородская область',
  'Новосибирская область',
  'Омская область',
  'Оренбургская область',
  'Орловская область',
  'Пензенская область',
  'Пермский край',
  'Приморский край',
  'Псковская область',
  'Республика Адыгея',
  'Республика Алтай',
  'Республика Башкортостан',
  'Республика Бурятия',
  'Республика Дагестан',
  'Республика Ингушетия',
  'Республика Калмыкия',
  'Республика Карелия',
  'Республика Коми',
  'Республика Крым',
  'Республика Марий Эл',
  'Республика Мордовия',
  'Республика Саха (Якутия)',
  'Республика Северная Осетия',
  'Республика Татарстан',
  'Республика Тыва',
  'Республика Хакасия',
  'Ростовская область',
  'Рязанская область',
  'Самарская область',
  'Санкт-Петербург',
  'Саратовская область',
  'Сахалинская область',
  'Свердловская область',
  'Севастополь',
  'Смоленская область',
  'Ставропольский край',
  'Тамбовская область',
  'Тверская область',
  'Томская область',
  'Тульская область',
  'Тюменская область',
  'Удмуртская республика',
  'Ульяновская область',
  'Хабаровский край',
  'Ханты-Мансийский АО',
  'Херсонская область',
  'Челябинская область',
  'Чеченская республика',
  'Чувашская республика',
  'Чукотский АО',
  'Ямало-Ненецкий АО',
  'Ярославская область',
]

const StateSelect = ({
  label = 'Область/край:',
  theme = 'gray',
  placeholder = 'Выбери',
  ...props
}): React.ReactElement => {
  return (
    <Select theme={theme} placeholder={placeholder} label={label} {...props}>
      {states.map((el) => {
        return (
          <SelectItem value={el} key={el}>
            {el}
          </SelectItem>
        )
      })}
    </Select>
  )
}

export default StateSelect
